import { isEmpty } from 'underscore';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config } from 'sanitize-text/sanitizers/SanitizeConfiguration';

// @ts-expect-error types missing
import { getEditableLegalConsentKeysForLegalConsentType } from 'FormsCommonComponents/lib/LegalConsent';
import { EditableLegalConsentKeys, ValidationErrors } from 'FormsCommonComponents/constants/LegalConsent';
export const isContentEmpty = value => {
  const textValue = sanitize(value, config.TEXTONLY);
  if (isEmpty(textValue)) {
    return ValidationErrors.REQUIRED;
  }
  return null;
};
export const getLegalConsentWarnings = ({
  legalConsent,
  currentLegalConsentType
}) => {
  const warnings = getEditableLegalConsentKeysForLegalConsentType(currentLegalConsentType).reduce((memo, key) => {
    const value = legalConsent.get(key);
    const maybeError = isContentEmpty(value);
    if (!isEmpty(maybeError)) {
      memo[key] = maybeError;
    }
    return memo;
  }, {});
  return warnings;
};
export const getLegalConsentErrors = ({
  legalConsent,
  currentLegalConsentType
}) => {
  const validations = getEditableLegalConsentKeysForLegalConsentType(currentLegalConsentType).reduce((memo, key) => {
    const value = legalConsent.get(key);
    if (key === EditableLegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES) {
      value.forEach(({
        communicationTypeId,
        label
      }) => {
        const maybeError = isContentEmpty(label);
        if (!isEmpty(maybeError)) {
          memo[`${key}.${communicationTypeId}`] = maybeError;
        }
      });
      return memo;
    } else if (key === EditableLegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL || currentLegalConsentType === 'LEGITIMATE_INTEREST' && key === EditableLegalConsentKeys.PRIVACY_POLICY_TEXT) {
      const maybeError = isContentEmpty(value);
      if (!isEmpty(maybeError)) {
        memo[key] = maybeError;
      }
      return memo;
    }
    return memo;
  }, {});
  return validations;
};